import { CSSObject } from "@emotion/react";

import { constants, mediaQueryStyles } from "@newsela/angelou";

const {
  breakpoints: { BreakpointNames },
} = constants;
const { mediaQuery } = mediaQueryStyles;

export const titleAndSubtitleContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",

  [mediaQuery.upTo(BreakpointNames.sm)]: {
    width: "100%",
    padding: "0 0 8px 0",
  },
};
